import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  icon: {
    marginRight: 10,
  },
})

export default useStyles
